import { GetCustomerHistoryRequest, GetCustomerHistoryResponse, CustomerContactStatusRequest, CustomerContactStatusResponse, CustomerContactEmailChangeRequest, CustomerContactEmailChangeResponse, SendContactConfirmationRequest, SendContactConfirmationResponse, SaveContactConfirmationRequest, SaveContactConfirmationResponse, LandingpageRequest, LandingpageResponse, LandingpageEmailWithTokenRequest } from './apimodel';
import { UrlBuilderRequest } from './UrlBuilderRequest';
//import { Redirect } from "react-router-dom";
import { loadStorageData } from '../util/store';
import LinkedappBackend from "../services/LinkedappBackend";
//import Error404 from '../pages/error404/Error404';


export class LinkedAppJSONHTTPBinding {
  baseURL: URL;
  basePath: string = '';

  public constructor(basePath: string) {
    this.baseURL = new URL(window.document.URL);
    this.basePath = basePath;
  }


  error401()  {
    function getParameter(name: string) {
      let params = new URLSearchParams(window.location.href);
      return params.get(name) || '';
    }

    // Cookie wegtreten: neue Authentifizierung nötig.
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    let kundenakteShortUrl = loadStorageData("kundenakteShortUrl") as string | undefined;
    if (!kundenakteShortUrl) {
      kundenakteShortUrl = getParameter("kundenakteShortUrl");
      if (kundenakteShortUrl && !kundenakteShortUrl.startsWith("http")) {
        LinkedappBackend
          .getRedirectUrl(kundenakteShortUrl, getParameter("cid") as "rd" | "rl" | "cl", "linkedapp")
          .then(result => {
            if (result !== undefined) {
              window.location.replace(result);
            }
            else {
              window.location.replace("/neuladen");
            }
          }).catch(() => window.location.replace("/neuladen"));
      }
    }
    else {
      window.location.replace(kundenakteShortUrl);
    }
  };

  public doFetchWithRetry = async (url: URL, request: any, tries = 3): Promise<any> => {

    function getParameter(name: string) {
      let params = new URLSearchParams(window.location.href);
      return params.get(name) || '';
    }
    
    return new Promise(async function (resolve, reject) {
      for (let i = 0; i < tries; i++) {
        if (i > 0) { console.log('Retrying request... %s', i + 1) };
        try {
          let response = await fetch(url.toString(), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(request) });
          if (401 === response.status) {
            
        
            // Cookie wegtreten: neue Authentifizierung nötig.
            document.cookie.split(";").forEach((c) => {
              document.cookie = c
                .replace(/^ +/, "")
                .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
            });
            let kundenakteShortUrl = loadStorageData("kundenakteShortUrl") as string | undefined;
            if (!kundenakteShortUrl) {
              kundenakteShortUrl = getParameter("kundenakteShortUrl");
              if (kundenakteShortUrl && !kundenakteShortUrl.startsWith("http")) {
                LinkedappBackend
                  .getRedirectUrl(kundenakteShortUrl, getParameter("cid") as "rd" | "rl" | "cl", "linkedapp")
                  .then(result => {
                    if (result !== undefined) {
                      window.location.replace(result);
                    }
                    else {
                      window.location.replace("/neuladen");
                    }
                  }).catch(() => window.location.replace("/neuladen"));
              }
            }
            else {
              window.location.replace(kundenakteShortUrl);
            }
          }
          if (401 !== response.status || tries - 1 === i) {
            // Anderer Status als 401: kein Retry. 
            response.json().then(res => {
              if (response.ok) {
                resolve(res);
              } else {
                reject(res);
              }
            });
            break;
          }
        }
        catch (err) {
          reject(err);
        }
      }
    });
  };

  
  public getCustomerHistory(arg0: GetCustomerHistoryRequest): Promise<GetCustomerHistoryResponse> {
    const url: URL = new URL(this.basePath + '/services/linkedapp/rest/api/getCustomerHistory', this.baseURL);
    return this.doFetchWithRetry(url, arg0);
  }

  public getLinkedAppRedirectUrl(arg0: UrlBuilderRequest): Promise<any> {
    const url = new URL(`${this.basePath}/services/linkedapp/rest/api/url/build/absolute?url=${arg0?.relativeUrl}&cid=${arg0?.cid}&app=${arg0?.app}`, this.baseURL);

    return new Promise<any>(async function (resolve, reject) {
      const response = await fetch(url.toString());
      if (response.ok === true) {

        resolve(response.text())

      }
      else {
        reject(response.text())
      }
    });

  }

  public getLinkedAppLinkUnsubscribe(request: any): Promise<string> {
    const url = new URL(`${this.basePath}/services/linkedapp/rest/api/linkedapp/link/unsubscribe`, this.baseURL);
    console.log("Send request", request)
    return new Promise<any>(async function (resolve, reject) {
      const response = await fetch(url.toString(), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(request) });
      if (response.ok === true) {
        resolve(response.json())
      }
      else {
        reject(response.json())
      }
    });
  }

  public sendContactConfirmation(arg0: SendContactConfirmationRequest): Promise<SendContactConfirmationResponse> {
    const url = new URL(this.basePath + '/services/linkedapp/rest/api/sendContactConfirmation', this.baseURL);

    return fetch(url.toString(), {method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(arg0)}).then(res => 
      {
        return res.json().then(json => {
          return res.ok ? json : Promise.reject(json);
        });
      }
    );
  }

  public unsubscribe(request: any): Promise<boolean> {
    const url = new URL(`${this.basePath}/services/linkedapp/rest/api/unsubscribe`, this.baseURL);
    console.log("Send request", request)
    return new Promise<boolean>(async function (resolve, reject) {
      const response = await fetch(url.toString(), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(request) });
      if (response.ok === true) {
        response.json().then(r => resolve(r.success === true)).catch(() => resolve(false));
      }
      else {
        reject(false);
      }
    });
  }


  public logout(): string {
    const url = new URL(this.basePath + '/services/linkedapp/rest/api/logout', this.baseURL);
    return url.toString();
  }

  public getCustomerContactStatus(arg0: CustomerContactStatusRequest): Promise<CustomerContactStatusResponse> {
    const url = new URL(this.basePath + '/services/linkedapp/rest/api/contactconfirmationstatus', this.baseURL);

    return fetch(url.toString(), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(arg0) }).then(res => {
      if (401 === res.status) {
        this.error401();
      }
      return res.json().then(json => {
        return res.ok ? json : Promise.reject(json);
      });
    }
    );
  }



  public getLandingpageLink(arg0: LandingpageRequest): Promise<LandingpageResponse> {
    const url = new URL(this.basePath + '/services/linkedapp/rest/api/landingpage/generatelink', this.baseURL);

    return fetch(url.toString(), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(arg0) }).then(res => {
      if (401 === res.status) {
        this.error401();
      }
      return res.json().then(json => {
        return res.ok ? json : Promise.reject(json);
      });
    }
    );
  }


  public getLandingpageLinkForEmailWithToken(arg0: LandingpageEmailWithTokenRequest): Promise<LandingpageResponse> {
    const url = new URL(this.basePath + '/services/linkedapp/rest/api/landingpage/generatelinkforemailwithtoken', this.baseURL);

    return fetch(url.toString(), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(arg0) }).then(res => {
      if (401 === res.status) {
        this.error401();
      }
      return res.json().then(json => {
        return res.ok ? json : Promise.reject(json);
      });
    }
    );
  }

  public setCustomercontactemailchange(arg0: CustomerContactEmailChangeRequest): Promise<CustomerContactEmailChangeResponse> {
    const url = new URL(this.basePath + '/services/linkedapp/rest/api/customercontactemailchange', this.baseURL);

    return fetch(url.toString(), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(arg0) }).then(res => {
      if (401 === res.status) {
        this.error401();
      }
      return res.json().then(json => {
        return res.ok ? json : Promise.reject(json);
      });
    }
    );
  }


  public saveContactConfirmation(arg0: SaveContactConfirmationRequest): Promise<SaveContactConfirmationResponse> {
    const url = new URL(this.basePath + '/services/linkedapp/rest/api/saveContactConfirmation', this.baseURL);

    return fetch(url.toString(), {method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(arg0)}).then(res => 
      {
        return res.json().then(json => {
          return res.ok ? json : Promise.reject(json);
        });
      }
    );
  }

}

